import queryClient from 'app/apiService/queryClient';
import apiService from 'app/apiService';
import { header } from 'utils/auth';
import { request } from 'utils/request';

export const DEALERS_QUERY_KEY = ['dealers'];

type HeaderDealerListItem = Record<string, unknown> & {
  _id?: string;
  dealer?: string;
  site_title?: string;
  name?: string;
  status?: string;
};

export function normalizeDealersListResponse(response: unknown) {
  const responseData = JSON.parse(JSON.stringify(response)) as {
    body?: { items?: HeaderDealerListItem[] };
  };

  if (!responseData.body?.items?.length) {
    return responseData;
  }

  responseData.body.items = responseData.body.items
    .map(
      (item): HeaderDealerListItem => ({
        ...item,
        dealer: String(item._id || ''),
        site_title: String(item.name || ''),
      }),
    )
    .sort((a, b) => {
      if (a.status !== 'ACTIVE' && b.status === 'ACTIVE') {
        return 1;
      }
      if (a.status === 'ACTIVE' && b.status !== 'ACTIVE') {
        return -1;
      }
      return String(a.name || '').toLowerCase() > String(b.name || '').toLowerCase()
        ? 1
        : -1;
    });

  return responseData;
}

export async function fetchDealersListForHeader() {
  await apiService.invalidateCacheByPrefix('api/v2/dealers', 'GET');

  const response = await request('/api/v2/dealers', {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: header(),
    }),
  });

  if ((response as { statusCode?: number })?.statusCode === 500) {
    throw new Error('Error fetching dealers list');
  }

  const responseData = normalizeDealersListResponse(response);
  queryClient.setQueryData(DEALERS_QUERY_KEY, responseData);
  return responseData;
}

export function findDealerInDealersList(
  items: HeaderDealerListItem[] | undefined,
  dealerId: string,
): HeaderDealerListItem | null {
  if (!items?.length) {
    return null;
  }

  return (
    items.find(item => item._id === dealerId || item.dealer === dealerId) ?? null
  );
}
